import React from "react";
import "../Styles/Footer.css"

const Footer = () =>{

    return (
        <div className="footer-div">
        </div>
    )
}

export default Footer;